import React, { useState } from "react";
import PropTypes from "prop-types";
import CFSelect from "../shared/forms/CFSelect";

const FieldColumnSelect = ({ field_slugs, selected_slugs }) => {
  const options = (field_slugs || []).map((slug) => ({
    value: slug,
    label: slug,
  }));

  const initialValue = (selected_slugs || [])
    .map((slug) => options.find((o) => o.value === slug))
    .filter(Boolean);

  const [selected, setSelected] = useState(initialValue);

  return (
    <>
      <CFSelect
        options={options}
        value={selected}
        onChange={(val) => setSelected(val || [])}
        isMulti={true}
        isClearable={true}
        placeholder="All fields"
        className=""
      />
      {selected.map((opt) => (
        <input
          key={opt.value}
          type="hidden"
          name="selected_fields[]"
          value={opt.value}
        />
      ))}
    </>
  );
};

FieldColumnSelect.propTypes = {
  field_slugs: PropTypes.arrayOf(PropTypes.string),
  selected_slugs: PropTypes.arrayOf(PropTypes.string),
};

export default FieldColumnSelect;
